import ActionButton from "./ActionButton";

const DownloadButton = ({ onClick, disabled, classes }) => (
    <ActionButton disabled={disabled} onClick={onClick} classes={`${classes} action-but ${!disabled ? "enable-but" : ""}`}>
        <i className="fas fa-download"></i>
    </ActionButton>
);

export default DownloadButton;